import { get } from "@insite/client-framework/Services/ApiService";
import { GetCategoryByIdApiParameter } from "@insite/client-framework/Services/CategoryService";
import { CategoryModel } from "@insite/client-framework/Types/ApiModels";

const categoriesUrl = "/api/v1/categories";

export async function getCategoryById(parameter: GetCategoryByIdApiParameter) {
    const categoryModel = await get<CategoryModel>(`${categoriesUrl}/${parameter.id}`, parameter);
    const category = categoryModel ?? undefined;
    return category;
}
